import { Pie } from "@ant-design/plots";

import { useGraphTheme } from "../../../hooks/useGraphTheme";

const AnalyticsGenericPieGraph = ({ data }) => {
  const graphTheme = useGraphTheme();
  const config = {
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.8,
    ...graphTheme,
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5
      },
      ...graphTheme.legend
    }
  };
  return <Pie {...config} />;
};

export default AnalyticsGenericPieGraph;
